export const SOFTLINE_API_SELF_CHECKOUT_CART = 'pointofsale-service/point-of-sale/cart';
export const SOFTLINE_API_SELF_CHECKOUT_CART_GET =
  'pointofsale-service/point-of-sale/cart/{{cartId}}';
export const SOFTLINE_API_SELF_CHECKOUT_CART_UPDATE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}';
export const SOFTLINE_API_SELF_CHECKOUT_CART_DELETE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}';
export const SOFTLINE_API_SELF_CHECKOUT_ITEMS_SCAN =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cart-items/scan/{{type}}/{{code}}';
export const SOFTLINE_API_SELF_CHECKOUT_CART_ITEM_UPDATE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cart-items/{{key}}';
export const SOFTLINE_API_SELF_CHECKOUT_CART_ITEM_DELETE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cart-items/{{key}}';
export const SOFTLINE_API_SELF_CHECKOUT_CUSTOMER_CARD_SCAN =
  'pointofsale-service/point-of-sale/customer-cards/scan/{{type}}/{{code}}';
export const SOFTLINE_API_SELF_CHECKOUT_CART_PAYMENT =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/payment';
export const SOFTLINE_API_SELF_CHECKOUT_CART_FINALIZE =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/finalize';
export const SOFTLINE_API_SELF_CHECKOUT_DIGITAL_RECEIPT =
  'pointofsale-service/point-of-sale/digital-receipt/download';

export const SOFTLINE_API_SELF_CHECKOUT_CASHBOOK_ENTRY =
  'pointofsale-service/point-of-sale/cart/{{cartId}}/cashbook-entry/{{id}}';

// TOUCH
export const SOFTLINE_API_SELF_CHECKOUT_TOUCH_CATEGORIES =
  'pointofsale-service/point-of-sale/no-scan-categories';
export const SOFTLINE_API_SELF_CHECKOUT_TOUCH_CATEGORY_PRODUCTS =
  'pointofsale-service/point-of-sale/no-scan-categories/{{categoryId}}/products';
export const SOFTLINE_API_SELF_CHECKOUT_TOUCH_CATEGORY_IMAGE =
  'pointofsale-service/point-of-sale/no-scan-categories/{{categoryId}}/image';
export const SOFTLINE_API_SELF_CHECKOUT_TOUCH_PRODUCT_IMAGE =
  'pointofsale-service/point-of-sale/products/{{productId}}/image';
